export const GET_SUPPORT = "GET_SUPPORT"
export const SET_SUPPORT = "SET_SUPPORT"
export const SET_SUPPORT_STATE = "SET_SUPPORT_STATE"

export const CLOSE_SUPPORT = "CLOSE_SUPPORT"
